export default __webpack_public_path__ + "static/media/Maithili_agri_f.bc1a72de.wav";